(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormBuilderState', FormBuilderState);

    function FormBuilderState(lodash) {
        return function(model) {
            return {
                set: set,
                destroy: destroy
            };

            function set(field, value) {
                lodash.set(model, field, value);
            }

            function destroy() {
                model = {};
            }
        };
    }
})();